import { render } from "./AclListRulesTab.vue?vue&type=template&id=dbc414f8&scoped=true"
import script from "./AclListRulesTab.vue?vue&type=script&lang=js"
export * from "./AclListRulesTab.vue?vue&type=script&lang=js"

import "./AclListRulesTab.vue?vue&type=style&index=0&id=dbc414f8&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc414f8"]])

export default __exports__